import { useState } from 'react';
import { Box } from '@mui/material';
import FileDropArea from '../../../Atoms/FileDropArea';
import { TextSpan } from '../../../Atoms/Text';
import { invoiceFileRefusal } from './pdfInvoice';
import { AttachedInvoice } from './AttachedInvoice';

export interface InvoiceDropZoneProps {
  file: File | null;
  disabled: boolean;
  onChange: (file: File | null) => void;
}

/** One PDF invoice, dropped or browsed for; any other file is refused with a message under the zone. */
export const InvoiceDropZone = ({ file, disabled, onChange }: InvoiceDropZoneProps) => {
  const [refusal, setRefusal] = useState<string | null>(null);

  const choose = ([chosen]: File[]) => {
    const refused = invoiceFileRefusal(chosen);
    setRefusal(refused);
    if (!refused) onChange(chosen);
  };

  return (
    <Box className="flex flex-col gap-2">
      <FileDropArea
        instructions="Drag an invoice here or"
        buttonText="browse"
        browseAs="link"
        subInstructions="Accepted: PDF"
        allowedFileTypes={['.pdf', 'application/pdf']}
        multiple={false}
        allowRepick
        disabled={disabled}
        testId="invoice-drop-zone"
        onFileDrop={choose}
      />
      {refusal && (
        <Box role="alert">
          <TextSpan
            size="xs"
            color="red">
            {refusal}
          </TextSpan>
        </Box>
      )}
      {file && (
        <AttachedInvoice
          file={file}
          disabled={disabled}
          onRemove={() => onChange(null)}
        />
      )}
    </Box>
  );
};
